import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UiProfileSidebarComponent } from './ui-profile-sidebar.component';
import { FeatureImgCloudModule } from '@unico-people/feature-img-cloud';

@NgModule({
  declarations: [UiProfileSidebarComponent],
  exports: [UiProfileSidebarComponent],
  imports: [CommonModule, RouterModule, FeatureImgCloudModule]
})
export class UiProfileSidebarModule {}
